import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '8fr 40fr 8fr 8fr 8fr 9fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    height: 100,
    textAlign: 'unset',
    [theme.breakpoints.down(768)]: {
      gridTemplateColumns: '2fr 0.1fr 2fr 0.3fr'
    },
    cursor: 'pointer'
  },
  nameCell: {
    display: 'flex'
  },
  iconSize: {
    fontSize: 42
  },
  toolTip: {
    direction: 'ltr'
  },
  isSmallTypography: {
    fontSize: 14,
    fontWeight: 800
  }
}))

export default useStyles
